document.addEventListener("DOMContentLoaded", () => {
  const mediaBlocks = document.querySelectorAll(".product-guide__media-content");

  mediaBlocks.forEach((block) => {
    const video = block.querySelector("video");
    if (!video) return;

    const autoplayEnabled = block.dataset.videoAutoplay === "true";
    const controlsEnabled = block.dataset.videoControls === "true";

    let isPlaying = !video.paused;

    // Respect theme setting for controls
    if (controlsEnabled) {
      video.setAttribute("controls", "true");
    } else {
      video.removeAttribute("controls");
    }

    // Autoplay should stay muted/playsinline for browser compatibility
    if (autoplayEnabled) {
      video.muted = true;
      video.setAttribute("muted", "");
      video.setAttribute("playsinline", "");
      video.play().catch(() => {
        // Browser may still block autoplay in some cases
      });

      block.classList.add("video-playing");
      isPlaying = true;
    }

    block.addEventListener("click", (e) => {
      // If controls are enabled, let the native video UI handle clicks
      if (controlsEnabled && e.target.tagName.toLowerCase() === "video") return;

      if (!isPlaying) {
        video.play();

        if (controlsEnabled) {
          video.setAttribute("controls", "true");
        }

        block.classList.add("video-playing");
        isPlaying = true;
      } else {
        video.pause();

        // Only remove controls if setting says controls should be hidden
        if (!controlsEnabled) {
          video.removeAttribute("controls");
        }

        block.classList.remove("video-playing");
        isPlaying = false;
      }
    });

    video.addEventListener("pause", () => {
      if (!controlsEnabled) {
        video.removeAttribute("controls");
      }

      block.classList.remove("video-playing");
      isPlaying = false;
    });

    video.addEventListener("ended", () => {
      if (!controlsEnabled) {
        video.removeAttribute("controls");
      }

      block.classList.remove("video-playing");
      isPlaying = false;
    });

    video.addEventListener("fullscreenchange", () => {
      video.classList.toggle("pointer-events-all");
    });
  });
});
